"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOrganizationBillingHierarchyQuery = exports.useGetTransactionsQuery = exports.useGetTransactionTypesQuery = exports.useGetGiftingActivityByGroupIdQuery = exports.useLazyGetTransactionsReportQuery = exports.useGetBalanceByAccountIdQuery = exports.useGetBillingGroupsQuery = exports.BillingApiTag = exports.giftingActivityAdapter = exports.billingGroupAdapter = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toolkit = require("@reduxjs/toolkit");

var _utils = require("@alycecom/utils");

var _EmptyAppApi = require("../EmptyAppApi");

var _cacheTime = require("../../constants/cacheTime.constants");

var _types = require("./types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var billingGroupAdapter = (0, _toolkit.createEntityAdapter)({
  selectId: function selectId(group) {
    return group.groupId;
  }
});
exports.billingGroupAdapter = billingGroupAdapter;
var giftingActivityAdapter = (0, _toolkit.createEntityAdapter)({
  selectId: function selectId(group) {
    return group.groupId;
  }
});
exports.giftingActivityAdapter = giftingActivityAdapter;
var BillingApiTag;
exports.BillingApiTag = BillingApiTag;

(function (BillingApiTag) {
  BillingApiTag["BillingGroup"] = "BillingTagType__BillingGroup";
  BillingApiTag["BillingHierarchy"] = "BillingTagType__BillingHierarchy";
})(BillingApiTag || (exports.BillingApiTag = BillingApiTag = {}));

var billing = _EmptyAppApi.emptyAppApi.enhanceEndpoints({
  addTagTypes: [BillingApiTag.BillingGroup, BillingApiTag.BillingHierarchy]
}).injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getBillingGroups: build.query({
        query: function query(params) {
          return "/api/v1/groups?".concat((0, _utils.deepQueryStringWithPaths)(params));
        },
        transformResponse: function transformResponse(response) {
          return billingGroupAdapter.addMany(billingGroupAdapter.getInitialState(), response.data);
        },
        providesTags: [{
          type: BillingApiTag.BillingGroup,
          id: 'LIST'
        }]
      }),
      getBalanceByAccountId: build.query({
        query: function query(_ref) {
          var accountId = _ref.accountId,
              filters = _ref.filters;
          return "/api/v1/reporting/resources/".concat(accountId, "/balance?").concat((0, _utils.deepQueryStringWithPaths)({
            filters: filters
          }));
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      getTransactions: build.query({
        query: function query(_ref2) {
          var accountId = _ref2.accountId,
              filters = _ref2.filters;
          return "/api/v1/reporting/resources/deposits/".concat(accountId, "/operations?").concat((0, _utils.deepQueryStringWithPaths)(filters));
        }
      }),
      getTransactionsReport: build.query({
        query: function query(_ref3) {
          var accountId = _ref3.accountId,
              filters = _ref3.filters;
          return {
            url: "/api/v1/reporting/resources/export-deposit-ledger/".concat(accountId, "/operations?").concat((0, _utils.deepQueryStringWithPaths)(filters)),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            responseHandler: function responseHandler(response) {
              return response.blob();
            }
          };
        },
        onQueryStarted: function () {
          var _onQueryStarted = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_arg, _ref4) {
            var queryFulfilled;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    queryFulfilled = _ref4.queryFulfilled;
                    return _context.abrupt("return", queryFulfilled.then(function (result) {
                      (0, _utils.downloadFile)(result.data, 'Deposit-ledger-report.xlsx');
                    }));

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onQueryStarted(_x, _x2) {
            return _onQueryStarted.apply(this, arguments);
          }

          return onQueryStarted;
        }()
      }),
      getGiftingActivityByGroupId: build.query({
        query: function query(_ref5) {
          var groupId = _ref5.groupId,
              filters = _ref5.filters;
          return "/api/v1/reporting/resources/".concat(groupId, "/gifting-activity?").concat((0, _utils.deepQueryStringWithPaths)({
            filters: filters
          }));
        },
        transformResponse: function transformResponse(_ref6) {
          var _ref6$data = _ref6.data,
              grouped = _ref6$data.grouped,
              ungrouped = _ref6$data.ungrouped;
          return giftingActivityAdapter.addMany(giftingActivityAdapter.getInitialState(), [].concat((0, _toConsumableArray2["default"])(grouped), [{
            groupId: _types.GroupName.Ungrouped,
            groupName: _types.GroupName.Ungrouped,
            amountSpent: 0,
            amountAtTheStart: 0,
            amountAtTheEnd: 0,
            teams: ungrouped
          }]));
        }
      }),
      getTransactionTypes: build.query({
        query: function query() {
          return '/api/v1/reporting/resources/deposits/operations/category-types';
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        },
        keepUnusedDataFor: _cacheTime.DAY_CACHE_PERIOD
      }),
      getOrganizationBillingHierarchy: build.query({
        query: function query() {
          return '/api/v1/reporting/resources/hierarchy-with-deposits-group-grouped';
        },
        transformResponse: function transformResponse(_ref7) {
          var data = _ref7.data;
          return _objectSpread(_objectSpread({}, data), {}, {
            remainingTeamsTotal: {
              accountId: _types.GroupsTeamsIdentifier.Ungrouped,
              money: {
                amount: data.ungrouped.reduce(function (acc, team) {
                  return acc + team.deposits.reduce(function (teamTotal, depositTeam) {
                    return teamTotal + depositTeam.money.amount;
                  }, 0);
                }, 0)
              }
            }
          });
        },
        providesTags: [BillingApiTag.BillingHierarchy]
      })
    };
  }
});

var useGetBillingGroupsQuery = billing.useGetBillingGroupsQuery,
    useGetBalanceByAccountIdQuery = billing.useGetBalanceByAccountIdQuery,
    useLazyGetTransactionsReportQuery = billing.useLazyGetTransactionsReportQuery,
    useGetGiftingActivityByGroupIdQuery = billing.useGetGiftingActivityByGroupIdQuery,
    useGetTransactionTypesQuery = billing.useGetTransactionTypesQuery,
    useGetTransactionsQuery = billing.useGetTransactionsQuery,
    useGetOrganizationBillingHierarchyQuery = billing.useGetOrganizationBillingHierarchyQuery;
exports.useGetOrganizationBillingHierarchyQuery = useGetOrganizationBillingHierarchyQuery;
exports.useGetTransactionsQuery = useGetTransactionsQuery;
exports.useGetTransactionTypesQuery = useGetTransactionTypesQuery;
exports.useGetGiftingActivityByGroupIdQuery = useGetGiftingActivityByGroupIdQuery;
exports.useLazyGetTransactionsReportQuery = useLazyGetTransactionsReportQuery;
exports.useGetBalanceByAccountIdQuery = useGetBalanceByAccountIdQuery;
exports.useGetBillingGroupsQuery = useGetBillingGroupsQuery;